import { render, staticRenderFns } from "./Jzmx.vue?vue&type=template&id=36e73c2b&scoped=true"
import script from "./Jzmx.vue?vue&type=script&lang=js"
export * from "./Jzmx.vue?vue&type=script&lang=js"
import style0 from "./Jzmx.vue?vue&type=style&index=0&id=36e73c2b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e73c2b",
  null
  
)

export default component.exports